import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FiShoppingBag, FiX } from "react-icons/fi";

const ApprovalBanner = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hasBeenDismissed = localStorage.getItem("approvalBannerDismissed");
    if (!hasBeenDismissed) {
      setShow(true);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
    localStorage.setItem("approvalBannerDismissed", "true");
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[1031] animate-slide-up">
      <div className="bg-white border-t border-component-border shadow-2xl px-6 py-4 flex flex-col md:flex-row items-center justify-center gap-4 text-center">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-chafadi-primary text-white rounded-xl flex items-center justify-center shadow-lg shadow-orange-100">
            <FiShoppingBag size={20} />
          </div>
          <span className="font-black text-theme-text tracking-tight text-lg">Chafadi</span>
        </div>
        
        <p className="font-bold text-theme-text">{t("approvalBanner.message")}</p>
        
        <button 
          onClick={handleClose}
          className="md:absolute md:right-6 w-10 h-10 rounded-full bg-theme-bg text-theme-muted flex items-center justify-center hover:bg-gray-100 transition-all border border-component-border"
          aria-label="Dismiss"
        >
          <FiX />
        </button>
      </div>
    </div>
  );
};

export default ApprovalBanner;
